import React from 'react'
import PropTypes from 'prop-types'

import { Box, Tooltip, Typography } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

import T from 'T'
import HHDisplayMoney from 'components/common/HHDisplayMoney'

const RentalFeeServiceHeader = ({ serviceName, price, containerCount }) => {
  const containerText = `${containerCount} container${containerCount === 1 ? '' : 's'}`

  return (
    <Box sx={{ px: 3 }} display="flex" justifyContent="space-between">
      <Typography variant="h4" fontWeight={600} noWrap color="textSecondary">
        {`${serviceName} | `}
        <HHDisplayMoney value={price} formatToDollars={false} />
      </Typography>
      <Typography variant="h5" fontWeight={500} color="textSecondary" display="flex" alignItems="center" gap={0.5}>
        <Tooltip arrow placement="bottom" title={T.RENTAL_FEE_CONTAINER_LIMIT_TOOLTIP}>
          <InfoOutlinedIcon color="action" />
        </Tooltip>
        {containerText}
      </Typography>
    </Box>
  )
}

RentalFeeServiceHeader.propTypes = {
  serviceName: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  containerCount: PropTypes.number.isRequired,
}

export default RentalFeeServiceHeader
